import { type QConfigInformation } from '@exam-management/feature-qconfig-provider';

interface UseGetSelectedLOSProps {
  chapterId: string;
  qConfigStructures: QConfigInformation['structures'];
  defaultLOS?: string;
}

export function useGetSelectedLOS(props: Readonly<UseGetSelectedLOSProps>) {
  const { chapterId, qConfigStructures, defaultLOS } = props;

  const children = qConfigStructures.filter((structure) => structure.parentId === chapterId);

  return children.reduce<string[]>((acc, child) => {
    const LOS = qConfigStructures.find(
      (structure) =>
        structure.parentId === child.id &&
        structure.category === 'LEARNING_OBJECTIVE_STATEMENT' &&
        defaultLOS != structure.refId,
    );

    if (LOS?.refId) {
      acc.push(LOS.refId);
    }

    return acc;
  }, []);
}
